module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("I "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STRUCK")]), _vm._v(" the board, and cry’d, No more. I will abroad. What? shall I ever sigh and pine?")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent-b"
  }, [_vm._v("My lines and life are free; free as the road, Loose as the winde, as large as store. Shall I be still in suit? Have I no harvest but a thorn To let me blood, and not restore")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent-b"
  }, [_vm._v("What I have lost with cordiall fruit? Sure there was wine Before my sighs did drie it: there was corn Before my tears did drown it. Is the yeare onely lost to me? Have I no bayes to crown it?")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent-b"
  }, [_vm._v("No flowers, no garlands gay? all blasted? All wasted? Not so, my heart: but there is fruit, And thou hast hands. Recover all thy sigh-blown age")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent-b"
  }, [_vm._v("On double pleasures: leave thy cold dispute")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent-b"
  }, [_vm._v("Of what is fit, and not; forsake thy cage, Thy rope of sands,")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent-b"
  }, [_vm._v("Which pettie thoughts have made, and made to thee Good cable, to enforce and draw, And be thy law, While thou didst wink and wouldst not see. Away; take heed: I will abroad.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent-b"
  }, [_vm._v("Call in thy deaths head there: tie up thy fears. He that forbears To suit and serve his need, Deserves his load.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent-b"
  }, [_vm._v("But as I rav’d and grew more fierce and wilde At every word, Me thought I heard one calling, "), _c('i', [_vm._v("Childe:")]), _vm._v(" And I reply’d, "), _c('i', [_vm._v("My Lord")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('span', [_vm._v("GEORGE HERBERT")])]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('span', [_vm._v("(1593–1633)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495aa1af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 69
// module chunks = 0